import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useBatchService from '../../../app/services/hooks/useBatchService';

interface Props {
  batchId: number;
  checkValue: boolean;
  callbackSuccess: () => void;
}

const BatchSwitchChange = ({ batchId, checkValue, callbackSuccess }: Props) => {
  const { hideLoading } = useContext(AppContext);
  const [checked, setChecked] = React.useState<boolean>(checkValue);

  React.useEffect(() => {
    setChecked(!!checkValue);
  }, [checkValue]);

  const { activeBatch } = useBatchService();

  const active = (value: boolean) => {
    setChecked(value);

    activeBatch(batchId, value, {
      onSuccess: (response: ServiceResponse) => {
        if (hideLoading) hideLoading();
        useReactConfirmAlert().successAlert({
          title: 'Éxito',
          message: response.message
        });
        callbackSuccess();
      },
      onError: (response: ServiceResponse) => {
        if (hideLoading) hideLoading();
        setChecked(!value);
        useReactConfirmAlert().errorAlert({
          title: 'Error',
          message: response.message
        });
      }
    });
  };

  return <ActiveControl status={checked} id={batchId} callback={active} />;
};

export default BatchSwitchChange;
